import React from 'react';
import PropTypes from 'prop-types';
function withLoading(WrappedComponent, LoadingComponent, ErrorComponent) {
  // props specific to withLoading
  const propTypes = {
    /**
     * current status of the component
     * accepts either a string or array of strings
     */
    status: PropTypes.oneOfType([PropTypes.oneOf(['rejected', 'resolved', 'pending', 'init']), PropTypes.arrayOf(PropTypes.oneOf(['rejected', 'resolved', 'pending', 'init']).isRequired)]).isRequired
  };
  function WithLoading(props) {
    // convert single string to array
    function toArray(status) {
      status = [].concat(status);
      return status;
    }

    // get final status
    function getStatus(statuses) {
      if (statuses.includes('rejected')) return 'rejected';
      if (statuses.every(value => value === 'resolved')) return 'resolved';
      if (statuses.includes('init')) return 'init';
      return 'pending';
    }
    const currentStatus = getStatus(toArray(props.status));
    switch (currentStatus) {
      case 'resolved':
        return /*#__PURE__*/React.createElement(WrappedComponent, props);
      case 'rejected':
        return ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, props) : null;
      case 'init':
      case 'pending':
      default:
        return LoadingComponent ? /*#__PURE__*/React.createElement(LoadingComponent, null) : null;
    }
  }

  // sets displayName so react devtools displays a helpful component name
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithLoading.propTypes = propTypes;
  WithLoading.displayName = `${wrappedComponentName}WithLoading`;
  return WithLoading;
}
export default withLoading;